module.exports = __webpack_public_path__ + "img/fondo.74acd936.png";